import { postApv } from '../../apis';
import { getIframe, setAddEventListener } from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setAlertModal, showAlertModal } from '../components/alert';

const AccountAuth = {
  render: async () => {
    return `
    <div>
        <a id="connect_pay_back_button" class="c_back"></a>
    </div>
    <div class="c_title1">계좌 인증</div>
    <div class="c_label2_1 m_b_10">입력 계좌로 1원을 입금했습니다.</div>
    <div class="c_label5_1 m_b_40">입금내역에 표시된 3자리 숫자를 입력해주세요.</div>
    <div class="c_bod2 m_b_40">
        <div class="c_box m_b_10">
            <span class="c_label1">입금자명</span>
            <span class="c_label1">입금</span>
        </div>
        <div class="c_box">
            <div class="c_box_left">
                <span class="skin1_span c_span4">*</span>
                <span class="skin1_span c_span4 m_l_5">*</span>
                <span class="skin1_span c_span4 m_l_5">*</span>
            </div>
            <div class="c_label6_2">
                1원
            </div>
        </div>
    </div>
    <div class="form-group">
        <label class="c_label1">입금자명</label>
        <input id="ptst_txt" type="text" class="form-control c_input1 skin1_input" placeholder="3자리 숫자 입력">
    </div>
    <div class="bottom_btn_wrapper">
        <button id="account_auth_next" class="btn c_btn1 skin1_btn">다음</button>
    </div>
    `;
  },
  afterRender: async () => {
    // setAlertModal
    setAlertModal();

    setAddEventListener('account_auth_next', async () => {
      if (getIframe().getElementById('ptst_txt').value.trim() == '') {
        showAlertModal('알림', '입금자명을 입력해주세요.');
      } else {
        const state = history.state;

        // 1원인증 확인
        const data = {
          verifyTrDt: state.verifyTrDt,
          verifyTrNo: state.verifyTrNo,
          verifyVal: getIframe().getElementById('ptst_txt').value.trim(),
          bankCd: state.bankCd,
          acctNo: state.acctNo,
          membNm: state.membNm,
        };

        try {
          const res = await postApv('common/accountConfirm', data);

          // ARS인증 화면 이동
          pushRouter(
            {
              accEntyno: res.accEntyno,
            },
            null,
            routes.accountArsAuth.hashPath
          );
        } catch (e) {
          showAlertModal('오류', e.resultMessage);
          console.error(e);
        }
      }
    });
    setAddEventListener('connect_pay_back_button', () => history.back());
  },
};
export default AccountAuth;
